import type { CagePageInterface } from '@/routes/Client/Cage/utils/cage-pages-interface';

import CageWeightGraphsContainer from './CageWeightGraphsContainer';

export default function CageWeightGraphsProviderContainer({
    clientId,
    locationId,
    cageId,
}: CagePageInterface) {
    return (
        <CageWeightGraphsContainer clientId={clientId} locationId={locationId} cageId={cageId} />
    );
}
